export const ratingConfig = (data) => [
  {
    id: 1,
    nameforLink: "alert-objects",
    name: 'Объекты в "Пожаре"',
    amount: data?.totalFireObjectsAmount,
    percentage: null,
    color: "var(--orangeAccent)",
  },
  {
    id: 2,
    nameforLink: "maintenance-objects",
    name: 'Объекты в "ТО"',
    amount: data?.totalMaintenanceFacilities,
    percentage: null,
    color: "var(--accent)",
  },

  {
    id: 2,
    nameforLink: "overdued_jobs_amount",
    name: `Сообщений "Пожар" за смену`,
    amount: data?.messageChart?.fireMessagesAmount,
    percentage: null,
    color: "var(--redAccent)",
  },
  {
    id: 3,
    nameforLink: "near_deadline_jobs_amount",
    name: `Ложных сообщений "Пожар" за смену`,
    amount: data?.messageChart?.falseFireMessagesAmount,
    percentage: null,
    color: "var(--mainText)",
  },
  {
    id: 4,
    nameforLink: "no-link-objects",
    name: "Объекты без связи",
    amount: data?.noLinkObjectsCount,
    percentage: data?.noLinkObjectsCount,
    color: "var(--accent)",
  },
  {
    id: 5,
    nameforLink: "objects",
    name: "Всего объектов",
    amount: data?.totalObjectsAmount,
    percentage: data?.totalObjectsPercentage,
    color: "var(--accent)",
  },
];
